import React, { useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Avatar from "@material-ui/core/Avatar";

import Toolbar from "@material-ui/core/Toolbar";

import Logo from "../../../../Images/tenant_default_logo.png";
import MobileLogo from "../../../../Images/tenant_default_mobile_logo.png";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Chip from "@material-ui/core/Chip";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import useStyles from "./style";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import { clearUser } from "../../../../redux-tools/actions/userActions";
import auth from "../../../../services/authService";
import http from "../../../Common/RestAPIHandler";
import { format } from "date-fns-tz";
import { NavLink } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import PeopleAltIcon from "@material-ui/icons/PeopleAltOutlined";
import DescriptionIcon from "@material-ui/icons/DescriptionOutlined";
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { Tooltip } from "@material-ui/core";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import BusinessIcon from "@material-ui/icons/BusinessOutlined";
import DashboardIcon from '@material-ui/icons/Dashboard';
import ArchiveIcon from '@material-ui/icons/Archive';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { hasPermission } from "../../../Common/permission";

const ResellerPortalLayout = (props) => {
  const classes = useStyles();
  const [dateTime, setDateTime] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [delay, setDelay] = useState(0);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    http.Post(
      "reseller/logout/",
      null,
      () => {
        // Clear all localStorage after successful logout - don't preserve theme settings between different users
        localStorage.clear();
        auth.deleteToken();
        props.clearUser();
        props.history.replace(process.env.PUBLIC_URL + "/reseller/login");
      },
      () => {
        // Even if logout API fails, clear localStorage and redirect
        localStorage.clear();
        auth.deleteToken();
        props.clearUser();
        props.history.replace(process.env.PUBLIC_URL + "/reseller/login");
      }
    );
  };

  useEffect(() => {
    const interval = setTimeout(() => {
      var today = new Date();
      var dateFormat = format(today, "hh:mm|a|eeee|MMM dd, yyyy").split("|");
      setDateTime({
        time: dateFormat[0],
        ampm: dateFormat[1],
        dayName: dateFormat[2],
        date: dateFormat[3],
      });
      setDelay(62 - today.getSeconds());
    }, delay * 1000);
    return () => clearTimeout(interval);
  }, [dateTime, delay]);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Grid container spacing={1}>
        <Grid item xs={12} className={classes.appdiv}>
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.toolbarOne}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                direction="row"
                justify="flex-start"
              >
                <Grid item style={{ 
                  width: '15%', 
                  minWidth: '120px',

                  borderRadius: '10px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px'
                }}>
                  <img
                    src={Logo}
                    alt="Not Available"
                    className={`${classes.full_image}`}
                  />
                  <img
                    src={MobileLogo}
                    alt="Not Available"
                    className={`${classes.mobile_image}`}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={3}
                alignItems="center"
                direction="row"
                justify="flex-end"
              >
                <Grid item className={classes.headerRightGrid}>
                  <Grid container spacing={0} alignItems="center">
                    <Grid item className={classes.TimeHide}>
                      <div className={classes.time}>
                        {dateTime.time}
                        <sup className={classes.superscript}>
                          {dateTime.ampm}
                        </sup>
                      </div>
                    </Grid>
                    <Grid item className={classes.DateHide}>
                      <div className={classes.date}>
                        {dateTime.dayName}
                        <br></br> {dateTime.date}
                      </div>
                    </Grid>
                    <Grid item className={classes.accountChipContainer}>
                      <Chip
                        avatar={
                          <Avatar
                            alt="No Logo"
                            src={""}
                          />
                        }
                        label={"Hi " + 
                          props.user.first_name +
                          " " +
                          props.user.last_name
                        }
                        clickable
                        onClick={handleMenu}
                        onDelete={handleMenu}
                        deleteIcon={
                          <ArrowDropDownIcon
                            color="inherit"
                            className={classes.arrowIcon}
                          />
                        }
                        className={classes.hideChip}
                      />
                      <Avatar
                        className={classes.showProfileImage}
                        alt="No Logo"
                        src={""}
                        onClick={handleMenu}
                      />
                      <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        keepMounted
                        getContentAnchorEl={null}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                          style: {
                            width: 160,
                            borderRadius: 15,
                          },
                        }}
                      >
                        <MenuItem
                          onClick={(e) => {
                            props.history.replace(process.env.PUBLIC_URL + "/reseller/profile");
                            setAnchorEl(null);
                          }}
                          className={classes.menuItem}
                        >
                          My Profile
                        </MenuItem>
                        <Divider />
                        {hasPermission(props, ['Create/Modify Reseller Settings']) &&
                        <>
                        <MenuItem
                          onClick={(e) => {
                            props.history.replace(process.env.PUBLIC_URL + "/reseller/settings");
                            setAnchorEl(null);
                          }}
                          className={classes.menuItem}
                        >
                          Company Settings
                        </MenuItem>
                        <Divider />
                        </>
                        }
                        <MenuItem
                          onClick={handleLogOut}
                          className={classes.menuItem}
                        >
                          Log Out
                        </MenuItem>
                      </Menu>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item className={classes.navdiv}>
              <div className={classes.navbar}>
                <NavLink
                  className={classes.navLink + " " + ("/reseller/dashboard" === window.location.pathname?classes.active:"")}
                  to={process.env.PUBLIC_URL + "/reseller/dashboard"}
                >
                  <Tooltip title="Dashboard"><DashboardIcon/></Tooltip>
                  <span className={classes.navLinkText}>{props.user.reseller_name}
                  <KeyboardArrowRightIcon
                    style={{float:"right"}}
                  /></span>      
                </NavLink>
                <br/>
                <Divider />
                <br/>
                {hasPermission(props, ['Create/Modify Tenants']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/tenants" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/tenants"}
                    >
                      <Tooltip title="Tenants"><BusinessIcon/></Tooltip>
                      <span className={classes.navLinkText}>Tenants
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>      
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                  </>
                )}
                {hasPermission(props, ['Create/Modify Tenant Users']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/tenant_users" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/tenant_users"}
                    >
                      <Tooltip title="Tenant Users"><PeopleAltIcon/></Tooltip>
                      <span className={classes.navLinkText}>Tenant Users
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                  </>
                )}
                <NavLink
                  className={classes.navLink + " " + ("/reseller/packages" === window.location.pathname?classes.active:"")}
                  to={process.env.PUBLIC_URL + "/reseller/packages"}
                >
                  <Tooltip title="Packages"><DescriptionIcon/></Tooltip>
                  <span className={classes.navLinkText}>Packages
                  <KeyboardArrowRightIcon
                    style={{float:"right"}}
                  /></span>
                </NavLink>
                <br/>
                <Divider />
                <br/>
                {hasPermission(props, ['Access Billing']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/billing" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/billing"}
                    >
                      <Tooltip title="Billing"><CreditCardIcon/></Tooltip>
                      <span className={classes.navLinkText}>Billing
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                  </>
                )}
                {hasPermission(props, ['Create/Modify Reseller Users']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/reseller_users" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/reseller_users"}
                    >
                      <Tooltip title="Reseller Users"><PeopleAltIcon/></Tooltip>
                      <span className={classes.navLinkText}>Reseller Users
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                  </>
                )}
                {hasPermission(props, ['Create/Modify Reseller Roles']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/reseller_roles" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/reseller_roles"}
                    >
                      <Tooltip title="Reseller Roles"><PeopleAltIcon/></Tooltip>
                      <span className={classes.navLinkText}>Reseller Roles
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                  </>
                )}
                {hasPermission(props, ['Access Archives']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/archives" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/archives"}
                    >
                      <Tooltip title="Archives"><ArchiveIcon/></Tooltip>
                      <span className={classes.navLinkText}>Archives
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                  </>
                )}
                {hasPermission(props, ['Access Tenant Transfer']) && (
                  <>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/incomingTenants" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/incomingTenants"}
                    >
                      <Tooltip title="Incoming Tenants"><AddCircleIcon/></Tooltip>
                      <span className={classes.navLinkText}>Incoming Tenants
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                    <br/>
                    <Divider />
                    <br/>
                    <NavLink
                      className={classes.navLink + " " + ("/reseller/outgoingTenants" === window.location.pathname?classes.active:"")}
                      to={process.env.PUBLIC_URL + "/reseller/outgoingTenants"}
                    >
                      <Tooltip title="Outgoing Tenants"><RemoveCircleIcon/></Tooltip>
                      <span className={classes.navLinkText}>Outgoing Tenants
                      <KeyboardArrowRightIcon
                        style={{float:"right"}}
                      /></span>
                    </NavLink>
                  </>
                )}
                <footer className={classes.footerdiv}>
                  POWERED BY<br/> SYNCMONKEY
                </footer>
              </div>
            </Grid>
            <Grid item className={classes.maindiv}>
              <main>{props.children}</main>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

ResellerPortalLayout.propTypes = {};

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps, {
  clearUser,
})(ResellerPortalLayout);
